"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9947],{

/***/ 99902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ CautionOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32600);


const CautionOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "mask",
        attr: { id: "icon-99gp0dcgq", fill: "white" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.25 3.75C7.55558 3.75 3.75 7.55558 3.75 12.25C3.75 16.9444 7.55558 20.75 12.25 20.75C16.9444 20.75 20.75 16.9444 20.75 12.25C20.75 7.55558 16.9444 3.75 12.25 3.75ZM2.25 12.25C2.25 6.72715 6.72715 2.25 12.25 2.25C17.7728 2.25 22.25 6.72715 22.25 12.25C22.25 17.7728 17.7728 22.25 12.25 22.25C6.72715 22.25 2.25 17.7728 2.25 12.25ZM12.25 6.95459C12.6642 6.95459 13 7.29038 13 7.70459V13.1591C13 13.5733 12.6642 13.9091 12.25 13.9091C11.8358 13.9091 11.5 13.5733 11.5 13.1591V7.70459C11.5 7.29038 11.8358 6.95459 12.25 6.95459ZM13.25 16.7954C13.25 17.3477 12.8023 17.7954 12.25 17.7954C11.6977 17.7954 11.25 17.3477 11.25 16.7954C11.25 16.2431 11.6977 15.7954 12.25 15.7954C12.8023 15.7954 13.25 16.2431 13.25 16.7954Z"
            }
          }
        ]
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.25 3.75C7.55558 3.75 3.75 7.55558 3.75 12.25C3.75 16.9444 7.55558 20.75 12.25 20.75C16.9444 20.75 20.75 16.9444 20.75 12.25C20.75 7.55558 16.9444 3.75 12.25 3.75ZM2.25 12.25C2.25 6.72715 6.72715 2.25 12.25 2.25C17.7728 2.25 22.25 6.72715 22.25 12.25C22.25 17.7728 17.7728 22.25 12.25 22.25C6.72715 22.25 2.25 17.7728 2.25 12.25ZM12.25 6.95459C12.6642 6.95459 13 7.29038 13 7.70459V13.1591C13 13.5733 12.6642 13.9091 12.25 13.9091C11.8358 13.9091 11.5 13.5733 11.5 13.1591V7.70459C11.5 7.29038 11.8358 6.95459 12.25 6.95459ZM13.25 16.7954C13.25 17.3477 12.8023 17.7954 12.25 17.7954C11.6977 17.7954 11.25 17.3477 11.25 16.7954C11.25 16.2431 11.6977 15.7954 12.25 15.7954C12.8023 15.7954 13.25 16.2431 13.25 16.7954Z",
          fill: "#82869E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M4.75 12.25C4.75 8.10786 8.10786 4.75 12.25 4.75V2.75C7.00329 2.75 2.75 7.00329 2.75 12.25H4.75ZM12.25 19.75C8.10786 19.75 4.75 16.3921 4.75 12.25H2.75C2.75 17.4967 7.00329 21.75 12.25 21.75V19.75ZM19.75 12.25C19.75 16.3921 16.3921 19.75 12.25 19.75V21.75C17.4967 21.75 21.75 17.4967 21.75 12.25H19.75ZM12.25 4.75C16.3921 4.75 19.75 8.10786 19.75 12.25H21.75C21.75 7.00329 17.4967 2.75 12.25 2.75V4.75ZM12.25 1.25C6.17487 1.25 1.25 6.17487 1.25 12.25H3.25C3.25 7.27944 7.27944 3.25 12.25 3.25V1.25ZM23.25 12.25C23.25 6.17487 18.3251 1.25 12.25 1.25V3.25C17.2206 3.25 21.25 7.27944 21.25 12.25H23.25ZM12.25 23.25C18.3251 23.25 23.25 18.3251 23.25 12.25H21.25C21.25 17.2206 17.2206 21.25 12.25 21.25V23.25ZM1.25 12.25C1.25 18.3251 6.17487 23.25 12.25 23.25V21.25C7.27944 21.25 3.25 17.2206 3.25 12.25H1.25ZM14 7.70459C14 6.73809 13.2165 5.95459 12.25 5.95459V7.95459C12.1119 7.95459 12 7.84266 12 7.70459H14ZM14 13.1591V7.70459H12V13.1591H14ZM12.25 14.9091C13.2165 14.9091 14 14.1256 14 13.1591H12C12 13.0211 12.1119 12.9091 12.25 12.9091V14.9091ZM10.5 13.1591C10.5 14.1256 11.2835 14.9091 12.25 14.9091V12.9091C12.3881 12.9091 12.5 13.0211 12.5 13.1591H10.5ZM10.5 7.70459V13.1591H12.5V7.70459H10.5ZM12.25 5.95459C11.2835 5.95459 10.5 6.73809 10.5 7.70459H12.5C12.5 7.84266 12.3881 7.95459 12.25 7.95459V5.95459ZM12.25 18.7954C13.3546 18.7954 14.25 17.9 14.25 16.7954H12.25V18.7954ZM10.25 16.7954C10.25 17.9 11.1454 18.7954 12.25 18.7954V16.7954H10.25ZM12.25 14.7954C11.1454 14.7954 10.25 15.6908 10.25 16.7954H12.25V14.7954ZM14.25 16.7954C14.25 15.6908 13.3546 14.7954 12.25 14.7954V16.7954H14.25Z",
          fill: "#82869E",
          mask: "url(#icon-99gp0dcgq)"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 19947:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ActionButtons": function() { return /* binding */ ActionButtons; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35790);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(88384);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(21483);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(71323);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(24122);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20577);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(41873);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28247);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30630);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34090);
/* harmony import */ var helpers_confirm18YearsOld__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41796);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46586);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91987);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53028);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99902);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 14px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  height: 46px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  flex: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}













const DynamicCheckAgeModalContent = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(()=>__webpack_require__.e(/* import() */ 8004).then(__webpack_require__.bind(__webpack_require__, 88004)).then((mod)=>mod.CheckAgeModalDesktop), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(88004)
            ]
    }
});
const ActionButtons = ()=>{
    var ref;
    // TODO: use these 2 below states to catch message from Cart
    // when addToCart product having license
    // const [licenseWarningMessage, setLicenseWarningMessage] = useState('');
    // const [showLicenseWarningModal, setShowLicenseWarningModal] = useState(false);
    const { 0: showPopupCheckAge , 1: setShowPopupCheckAge  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const { product , primitiveProduct , isOutOfStock , isCanAddToCard , stockAvailable , price , payloadAddToCart , selectedPromotion ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useProductDetailState */ .W)();
    const { contactLink  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    const showToast = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .useToast */ .p)();
    const { onAddSingleItem  } = (0,contexts__WEBPACK_IMPORTED_MODULE_8__/* .useCartV2 */ .T)();
    const isValidPrice = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        if (!product) return false;
        if (price) return (price === null || price === void 0 ? void 0 : price.finalPrice) && (price === null || price === void 0 ? void 0 : price.finalPrice) >= 0;
    }, [
        product,
        price
    ]);
    const showContact = !isValidPrice || isOutOfStock || !(product === null || product === void 0 ? void 0 : (ref = product.status) === null || ref === void 0 ? void 0 : ref.sellable);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if ((0,helpers_confirm18YearsOld__WEBPACK_IMPORTED_MODULE_9__/* .needConfirm18YearsOld */ .a)((product === null || product === void 0 ? void 0 : product.isAlcoholicCategory) || false)) {
            setShowPopupCheckAge(true);
        }
    }, [
        product === null || product === void 0 ? void 0 : product.sku,
        product === null || product === void 0 ? void 0 : product.isAlcoholicCategory
    ]);
    const trackingPayload = JSON.stringify({
        sku: product === null || product === void 0 ? void 0 : product.sku,
        screenName: "productDetail"
    });
    const onAddItemToCart = async (type)=>{
        if (!isCanAddToCard) {
            var ref;
            (ref = showToast.info) === null || ref === void 0 ? void 0 : ref.call(showToast, {
                title: "",
                message: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Chỉ c\xf2n {{stockAvailable}} sản phẩm", {
                    stockAvailable: stockAvailable
                }),
                type: "error",
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .CautionOutlined */ .s, {
                    size: 50,
                    color: "#E24C4B"
                })
            });
            return;
        }
        if (!primitiveProduct) return;
        // Note: Remove function passLicenseCheck: logic check product's license at client
        // Cart will check this (instead of us)
        // task: https://jira.teko.vn/browse/CART21-994
        // params send to Teko tracking in event addToCart
        const trackAddToCartParams = {
            product: _objectSpreadProps(_objectSpread({}, primitiveProduct), {
                addToCartPrice: (price === null || price === void 0 ? void 0 : price.finalPrice) || 0
            }),
            selectedPromotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
            type
        };
        try {
            if (!(payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku)) return;
            const res = await onAddSingleItem({
                sku: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.sku,
                promotionId: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.promotionId,
                quantity: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.quantity,
                isPrimary: payloadAddToCart === null || payloadAddToCart === void 0 ? void 0 : payloadAddToCart.isPrimary
            });
            if (res) {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "success",
                    cartId: res.id
                }));
            } else {
                (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                    status: "failed"
                }));
            }
            if (res && type === _teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .AddToCartType.BUYNOW */ .h.BUYNOW) router.push("/cart");
        } catch (e) {
            (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_12__/* .trackAddToCart */ .Kc)(_objectSpreadProps(_objectSpread({}, trackAddToCartParams), {
                status: "failed"
            }));
            _teko_log__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .k.error(e);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            !showContact && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BuyNowButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        contentName: "buyNow",
                        regionName: "descriptionDetail",
                        target: "cart",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                            variant: "primary",
                            onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .AddToCartType.BUYNOW */ .h.BUYNOW),
                            className: "att-detail-page-buy-now-button",
                            block: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("Mua ngay").toUpperCase()
                            })
                        })
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AddToCartButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        contentName: "addToCart",
                        target: "productDetail",
                        regionName: "descriptionDetail",
                        payload: trackingPayload
                    })), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                            variant: "secondary",
                            onClick: ()=>onAddItemToCart(_teko_tracking__WEBPACK_IMPORTED_MODULE_13__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART),
                            block: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                                level: 2,
                                weight: "medium",
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("TH\xcaM V\xc0O GIỎ H\xc0NG")
                            })
                        })
                    }))
                ]
            }),
            showContact && !!contactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .CustomLink */ .x, {
                href: contactLink,
                target: "_blank",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactSaleButtonWrapper, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_14__/* .getTrackingData */ .O5)({
                    isTrackContent: true,
                    regionName: "descriptionDetail",
                    contentName: "contactSale",
                    target: "productDetail",
                    payload: trackingPayload
                })), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                        variant: "primary",
                        block: true,
                        marginTop: "s16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                            level: 2,
                            weight: "medium",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("LI\xcaN HỆ")
                        })
                    })
                }))
            }),
            showContact && !contactLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                disabled: true,
                block: true,
                marginTop: "s16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonText, {
                    level: 2,
                    weight: "medium",
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_10__.t)("HẾT H\xc0NG")
                })
            }),
            showPopupCheckAge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicCheckAgeModalContent, {
                show: showPopupCheckAge,
                onCancel: ()=>router.push("/"),
                onOk: ()=>{
                    (0,_teko_utils__WEBPACK_IMPORTED_MODULE_16__/* .setCookieOver18YearOld */ .zr)(true);
                    setShowPopupCheckAge(false);
                }
            })
        ]
    });
};
const ButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"].div(_templateObject());
const ButtonText = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_18__/* .SubTitle */ .DK)(_templateObject1());
const StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__/* .Button */ .z)(_templateObject2());
const BuyNowButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"].div(_templateObject3());
const AddToCartButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"].div(_templateObject4());
const ContactSaleButtonWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__["default"].div(_templateObject5());


/***/ }),

/***/ 46586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CL": function() { return /* binding */ trackRemoveFromCart; },
/* harmony export */   "Kc": function() { return /* binding */ trackAddToCart; },
/* harmony export */   "_g": function() { return /* binding */ trackChangeQuantityProduct; },
/* harmony export */   "bz": function() { return /* binding */ trackSelectProduct; },
/* harmony export */   "gu": function() { return /* binding */ trackManually; },
/* harmony export */   "ih": function() { return /* binding */ trackDecreaseQuantityProduct; },
/* harmony export */   "lM": function() { return /* binding */ trackIncreaseQuantityProduct; },
/* harmony export */   "wr": function() { return /* binding */ trackAddToCartManually; }
/* harmony export */ });
/* harmony import */ var _interface_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41873);
/* harmony import */ var _helper_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28247);



const trackAddToCart = (trackAddToCartParams) => {
  var _a;
  const {
    product,
    selectedPromotionId,
    status,
    cartId,
    type = _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART
  } = trackAddToCartParams;
  const { defaultPromotions = [] } = product;
  const trackingData = {
    cartId,
    skuId: product.productInfo.sku,
    skuName: product.productInfo.name,
    promotionId: `${[
      ...defaultPromotions.map((promo) => promo.id),
      selectedPromotionId || ""
    ].join(",")}`,
    status: status || "success",
    quantity: 1,
    price: parseInt(product.prices[0].supplierRetailPrice),
    promotionPrice: product.addToCartPrice
  };
  if (type === _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART) {
    window.track(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART, trackingData);
  } else {
    (0,_helper_es_js__WEBPACK_IMPORTED_MODULE_1__/* .trackCustomEvent */ .I)(_interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.BUYNOW */ .h.BUYNOW, {
      action: "click",
      category: "cart",
      label: JSON.stringify(trackingData),
      property: "product"
    });
  }
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: type,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: product.productInfo.name,
            id: product.productInfo.sku,
            price: product.addToCartPrice,
            quantity: 1,
            category: product.productInfo.categories,
            brand: product.productInfo.brand
          }
        ]
      }
    }
  });
};
const trackIncreaseQuantityProduct = (item, diff = 1, cartId) => {
  var _a;
  window.track("increaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity + diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: _interface_es_js__WEBPACK_IMPORTED_MODULE_0__/* .AddToCartType.ADDTOCART */ .h.ADDTOCART,
    ecommerce: {
      currencyCode: "VND",
      add: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: diff,
            category: ""
          }
        ]
      }
    }
  });
};
const trackDecreaseQuantityProduct = (item, diff = 1, cartId) => {
  window.track("decreaseQuantityProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity - diff,
    price: item.sellPrice,
    promotionPrice: item.price
  });
};
const trackChangeQuantityProduct = (item, newQty, cartId) => {
  const currQty = item.quantity;
  if (currQty < newQty) {
    trackIncreaseQuantityProduct(item, newQty - currQty, cartId);
  } else if (currQty > newQty) {
    trackDecreaseQuantityProduct(item, currQty - newQty, cartId);
  }
};
const trackRemoveFromCart = (item, cartId) => {
  var _a;
  window.track("removeFromCart", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    status: "success",
    quantity: item.quantity,
    price: item.sellPrice,
    promotionPrice: item.price
  });
  (_a = window.dataLayer) == null ? void 0 : _a.push({
    event: "removeFromCart",
    ecommerce: {
      remove: {
        products: [
          {
            name: item.name,
            id: item.sku,
            price: item.price,
            quantity: item.quantity,
            category: ""
          }
        ]
      }
    }
  });
};
const trackManually = (contentName, regionName, target, payload) => {
  window.track("manualTrackInteractionContent", {
    interaction: "click",
    contentName,
    regionName,
    target,
    payload
  });
};
const trackAddToCartManually = (trackingScreenName, sku) => {
  return trackManually("addToCart", "productCard", trackingScreenName, JSON.stringify({
    sku,
    screenName: trackingScreenName,
    index: 0
  }));
};
const trackSelectProduct = (item, checked, cartId) => {
  window.track(checked ? "selectProduct" : "unselectProduct", {
    cartId,
    skuId: item.sku,
    skuName: item.name,
    price: item.sellPrice,
    promotionPrice: item.price,
    quantity: item.quantity,
    status: "success"
  });
};




/***/ }),

/***/ 41873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ AddToCartType; }
/* harmony export */ });
var AddToCartType = /* @__PURE__ */ ((AddToCartType2) => {
  AddToCartType2["ADDTOCART"] = "addToCart";
  AddToCartType2["BUYNOW"] = "buy_now";
  return AddToCartType2;
})(AddToCartType || {});




/***/ })

}]);